import { css } from '@emotion/react'
import { Spacing } from '@opallabs/gem'

export const buttonOverrides = css({
  blockSize: 26,
  '&.icon-only': { paddingInline: Spacing.XS },
})
